import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGraphicSquareLiliacBg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={391}
    height={378}
    fill="none"
    viewBox="0 0 391 378"
    {...props}
  >
    <g fill="rgba(202, 190, 255, 0.15)" clipPath="url(#a)">
      <path d="M285.8 23.6c-16.9 3.1-24.3 4.5-47 8.6 6.9 37.9.3 77.4-19.1 111l41.4 23.9c25.1-43.4 33.7-94.5 24.7-143.5M32.8 208.1l9.1 30.9c22.9-7.2 47.5 11.1 47.1 35.2h32.3c.7-45.3-45.4-79.5-88.5-66.1M211.7 109.7l-41.2-14.8c-3.9 10.9-10 21.4-17.6 30.3l32.6 29.2c11.8-13.6 20.5-28.7 26.2-44.7M116.4 61.8h38.8C155.2 36.5 143 14 124.1 0H78.3v23.6c21 0 38.1 17.1 38.1 38.2M47.9 38.7 17 15.2c-23.9 29-19.6 78.9 9.2 103.3l26.3-28.6C38.2 77.8 36 53.1 47.9 38.7M0 356.8V378h127l-17.5-24.4C77.2 378 32.8 376.9 0 356.8M217.9 36.7c-2.1-13.1-6.1-25.4-11.6-36.7h-51.7c10.2 12.7 17.3 27.9 20.2 44.5zM52.4 343.1c6.8 0 13.5-1 20-3L63 309.2c-22 7.3-46.9-10.1-47.3-33.3l-15.7.8V319c13 15 32.4 24.4 52.4 24.1M370.1 234l-38-22.1c-28.2 25.6-94.4 109.8-153.4 166.2h60.5c10.3-11.2 20-22 29-31.3l33.6 31.3H365l-67.2-62.7z" />
      <path d="m219.3 240.9-108-102.6 18.1-19.2-25.7-28.8-49.7 53 27.8 26.4v-.1L189.6 272 148 315.6l42.2 18.2 200.7-211-50.2-9.9z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h390.9v378H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgGraphicSquareLiliacBg;
